import { resetPwd, setPwd } from "@/apis/user";
import { DialogLocal } from "@/components/Dialog";
import { useUserAuthContext } from "@/routes/routesAuths/userAuth";
import { useUserInfoStore } from "@/stores/userInfo";
import tools, { formatDuration, getServerTime } from "@/utils/tool";
import { AutoCenter, Form, Toast } from "antd-mobile";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
type Values = {
  newPassword: string;
  oldPassword: string;
  confirmPassword: string;
};
export const validateFields = (values: Values, extra?: any) => {
  if (extra.isBindPwd) {
    if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(values.oldPassword) || values.oldPassword.length < 6 || values.oldPassword.length > 15) return "请输入正确的旧密码";
  }
  if (!values.newPassword) {
    return `请输入${extra.isBindPwd ? "新" : ""}密码`;
  }
  if (extra.isBindPwd && !values.oldPassword) {
    return "请输入旧密码";
  }
  if (!values.confirmPassword) {
    return `请输入确认${extra.isBindPwd ? "新" : ""}密码`;
  }
  if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(values.newPassword) || values.newPassword.length < 6 || values.newPassword.length > 15) return "请输入6-15位字母数字组成的密码";
  if (values.newPassword !== values.confirmPassword) return "两次输入的密码不一致";
};
export const useSetup = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const {
    logout
  } = useUserAuthContext();
  const [userinfo, setUserInfo] = useUserInfoStore()(state => [state.userInfo, state.setUserInfo]);
  const isBindPwd = useMemo(() => {
    return userinfo.isEnteredPassword;
  }, [userinfo.isEnteredPassword]);
  useEffect(() => {
    const lastSettingPwdTime = userinfo.preResetPwdTime;
    if (lastSettingPwdTime) {
      const last = tools.dateFix(+lastSettingPwdTime * 1000);
      const now = getServerTime();
      const sevenDays = 7 * 24 * 60 * 60 * 1000;
      if (+last - now > sevenDays) {
        const duration = formatDuration(sevenDays - now + +last);
        DialogLocal({
          content: <AutoCenter>
              短期内你已修改过密码，请在${duration}后修改密码！
            </AutoCenter>,
          onConfirm: () => {
            navigate(-1);
          }
        });
      }
    }
  }, []);
  const fetchResetPwd = async (values: Values) => {
    const result = await resetPwd(values);
    if (result.ok) {
      setUserInfo({
        preResetPwdTime: getServerTime()
      });
      Toast.show(result.msg);
      logout();
    } else {
      Toast.show(result.msg);
    }
  };
  const fetchSetPwd = async (values: Values) => {
    const result = await setPwd({
      password: values.newPassword
    });
    if (result.ok) {
      setUserInfo({
        isEnteredPassword: true
      });
      Toast.show(result.msg);
      navigate(-1);
    } else {
      Toast.show(result.msg);
    }
  };
  return {
    form,
    userinfo,
    isBindPwd,
    fetchResetPwd,
    fetchSetPwd
  };
};

// // 修改密码
// if (this.$root.isBindPwd) {
//   if (
//     !/^(?![^a-zA-Z]+$)(?!\D+$)/.test(this.form.oldPassword) ||
//     this.form.oldPassword.length < 6 ||
//     this.form.oldPassword.length > 15
//   )
//     return this.$toast.fail("请输入正确的旧密码");
// }

// if (
//   !/^(?![^a-zA-Z]+$)(?!\D+$)/.test(this.form.newPassword) ||
//   this.form.newPassword.length < 6 ||
//   this.form.newPassword.length > 15
// )
//   return this.$toast.fail("请输入6-15位字母数字组成的密码");
// if (this.form.newPassword != this.form.confirmPassword)
//   return this.$toast.fail("两次输入的密码不一致");

// if (this.$root.isBindPwd) {
//   this.showFailDialog = true;
// } else {
//   // 设置初始密码
//   this.setPwd();
// }